var forgotEmailCodeController = {
    elForm: $('#forgotEmailCodeForm'),
    forgotModalCode: $('#forgotModalEmailCode'),
    forgotModalSetPass: $('#forgotModalSetPass'),
    code: '',
    submitting: false,
    init: function()
    {
        forgotEmailCodeController.clearForm();
        forgotEmailCodeController.elForm.find('.js-forgot-countdown').hide();
        forgotEmailCodeController.code = forgotEmailCodeController.elForm.find('.js-input-code').val();

        forgotEmailCodeController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        forgotEmailCodeController.elForm.find('.js-input-code').on('click change keyup blur input', function() {
            forgotEmailCodeController.code = $(this).val().trim();

            if(forgotEmailCodeController.code.length === 4) {
                forgotEmailCodeController.submitForm();
            } else {
                forgotEmailCodeController.clearForm();
            }

            return false;
        });
    },
    submitForm: function()
    {
        if (forgotEmailCodeController.submitting) {
            return false;
        }

        if (!forgotEmailCodeController.validateForm()) {
            forgotEmailCodeController.showError();

            return false;
        }

        forgotEmailCodeController.submitting = true;

        $.post(
            forgotEmailCodeController.elForm.attr('action'),
            forgotEmailCodeController.elForm.serialize(),
            function(data) {
                if (data.success) {
                    forgotEmailCodeController.forgotModalSetPass.data("forgot-type", "email");
                    forgotEmailCodeController.forgotModalSetPass.find('.go-back-modal')
                        .data('target', '#forgotModalEmailCode');
                    forgotEmailCodeController.forgotModalSetPass.modal('show');
                    forgotEmailCodeController.forgotModalSetPass.find('.js-input-username').val(
                        forgotEmailCodeController.elForm.find('.js-input-email').val()
                    );
                    forgotEmailCodeController.forgotModalCode.modal('hide');
                    forgotEmailCodeController.clearForm();
                    forgotEmailCodeController.elForm.find('.js-input-code').val('');
                } else {
                    if(data.message) {
                        forgotEmailCodeController.forgotModalCode.find('.error-text').text(data.message);
                        forgotEmailCodeController.showError();
                    }
                }
            }, 'json').always(function() {
                forgotEmailCodeController.submitting = false;
            });
    },
    validateForm: function()
    {
        forgotEmailCodeController.clearForm();
        return ($.isNumeric(forgotEmailCodeController.code) && forgotEmailCodeController.code.length === 4);
    },
    clearForm: function()
    {
        forgotEmailCodeController.elForm.find('.form-group').removeClass('has-error');
        forgotEmailCodeController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        forgotEmailCodeController.elForm.find('.form-group').addClass('has-error');
        forgotEmailCodeController.elForm.find('.error-text').show();
    }
};

$(function(){
    forgotEmailCodeController.init();
});